import api from './client';

export interface AbandonedCartCandidate {
  checkout_id: number | null;
  customer_name: string;
  email: string | null;
  product_titles: string;
  cart_total: number;
  hours_since_abandoned: number;
  recovery_url: string | null;
}

export interface AbandonedCartRecommendationItem {
  customer_name: string;
  product_titles: string;
  suggested_offer: string;
  email_subject: string;
  email_body: string;
  rationale: string;
}

export interface AbandonedCartRecovery {
  id: number;
  min_hours_since_abandoned: number;
  max_hours_since_abandoned: number;
  checkouts_analyzed: number;
  candidates: AbandonedCartCandidate[];
  ai_summary: string | null;
  ai_recommendations: AbandonedCartRecommendationItem[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GenerateAbandonedCartPayload {
  min_hours_since_abandoned?: number;
}

export const abandonedCartApi = {
  list: (page = 1) =>
    api.get<{ data: AbandonedCartRecovery[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/abandoned-carts?page=${page}`
    ),

  generate: (payload: GenerateAbandonedCartPayload = {}) =>
    api.post<{ data: AbandonedCartRecovery }>('/abandoned-carts/generate', payload),

  show: (id: number) => api.get<{ data: AbandonedCartRecovery }>(`/abandoned-carts/${id}`),

  destroy: (id: number) => api.delete(`/abandoned-carts/${id}`),
};
